/*eslint-disable */
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import moment from 'moment';
import PropTypes from 'prop-types';
import { isEmpty, values } from 'lodash';
import Pagination from '@mui/material/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import translating from '../../translate.json';

import './styles.scss';
import Button from 'components/Button';
import { Switch } from '@mui/material';

const TablePaginationComponent = ({
  headers,
  columns,
  rows,
  pagination,
  handleRowClick,
  handleRightClick,
  useUId
}) => {
  // let myPaddingStyle = {
  //   borderBottom: '13px solid #f5f5f5',
  //   background: 'white',
  //   backdropFilter: 'blur(2px)'
  // }
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('createdAt');
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [currentRows, setCurrentRows] = useState();
  const [count, setCount] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');

  const hasContent = (v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === 'string') return v.trim().length > 0;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'object') return Object.keys(v).length > 0;
    return true;
  };

  const handleChangeOrder = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (typeof b[orderBy] === 'object') {
      if (b[orderBy]?.name < a[orderBy]?.name) {
        return -1;
      }
      if (b[orderBy]?.name > a[orderBy]?.name) {
        return 1;
      }
    } else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
    }
    return 0;
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const handleChangePage = (e, number) => {
    setPage(number - 1);
  };

  function diff_hours(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
  }

  useEffect(() => {
    if (rows?.length) {
      if (!currentRows) setCurrentRows(rows);
      else if (rows !== currentRows) {
        setCurrentRows(rows);
        setPage(0);
      }
      if (rows.length % 10 === 0) setCount(rows.length / rowsPerPage);
      else setCount(Math.ceil(rows.length / rowsPerPage));
    }
  }, [rows]);

  return (
    <div>
      <TableContainer className="table-pagination">
        {rows && !isEmpty(rows) ? (
          <Table stickyHeader>
            <TableHead classes={{ root: 'tableHeaderRoot' }}>
              <TableRow>
                {headers?.map((header, key) => (
                  <TableCell
                    key={key}
                    classes={{ root: 'headerCellRoot' }}
                    align={'center'}
                  >
                    {/* {columns?.[key]?.sort ? ( */}
                    <TableSortLabel
                      active={orderBy === columns?.[key]?.value || false}
                      direction={
                        orderBy === columns?.[key]?.value ? order : 'asc'
                      }
                      onClick={() => handleChangeOrder(columns?.[key]?.value)}
                    >
                      {header}
                    </TableSortLabel>
                    {/* ) : (
                                            header
                                        )} */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {currentRows && (
              <TableBody classes={{ root: 'tableBodyRoot' }}>
                {stableSort(currentRows, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, indexKey) => {
                    return (
                      <TableRow
                        classes={{ root: 'tableBodyRowRoot' }}
                        hover={handleRowClick ? true : false}
                        role="checkbox"
                        tabIndex={-1}
                        key={indexKey}
                        onContextMenu={(e) =>
                          handleRightClick &&
                          handleRightClick(
                            row?.ClientProductId,
                            e,
                            row.product_type
                          )
                        }
                      >
                        {columns?.map((column, index) => {
                          let value;
                          let arrValues = [];
                          if (column.isArray) {
                            arrValues = column?.values?.map(
                              (val) => `${row[val]} `
                            );
                          } else {
                            value = row?.[column?.value];
                            if (column?.subField)
                              value = row?.[column?.value]?.[column?.subField];
                          }
                          const isArray = column?.isArray;
                          const isBold = column?.bold;
                          const Icon = column?.icon;
                          const handleAction = column?.handleAction;
                          const format = column?.format;
                          const now = new Date();
                          let isGreaterHourBefore = false;
                          if (Icon && handleAction) {
                            const createdDate = new Date(row.startDate);
                            if (
                              diff_hours(createdDate, now) > 1 &&
                              createdDate > now
                            )
                              isGreaterHourBefore = true;
                          }

                          return (
                            <TableCell
                              sortDirection={
                                orderBy === column.value ? order : false
                              }
                              key={`${index}-${index}`}
                              className={`${isBold ? 'cellcolor' : ''}`}
                              align={'right'}
                              onClick={(e) => {
                                if (!Icon)
                                  handleRowClick(
                                    useUId ? row.client_uuid : row.id,
                                    e,
                                    row
                                  );
                              }}
                            >
                              {Icon && index === columns.length - 1 ? (
                                <div className="action-icon">
                                  {isGreaterHourBefore && row.isActive ? (
                                    <Icon
                                      onClick={(e) => {
                                        handleAction(row?.id, e);
                                      }}
                                    ></Icon>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              ) : format ? (
                                format === 'date' ? (
                                  <div>
                                    {value
                                      ? moment(value).format('DD.MM.YYYY')
                                      : ''}
                                  </div>
                                ) : format === 'hour' ? (
                                  <div>
                                    {value ? moment(value).format('HH:mm') : ''}
                                  </div>
                                ) : format === 'link' ? (
                                  value && (
                                    <a target="_blank" href={value}>
                                      {'לינק'}
                                    </a>
                                  )
                                ) : format === 'detailsDialog' ? (
                                  hasContent(value) && (
                                    <Button
                                      txt={'צפייה'}
                                      handleClick={(e) => {
                                        e.stopPropagation();
                                        setDialogTitle(
                                          column?.dialogTitle || 'פרטים'
                                        );
                                        const content =
                                          typeof value === 'string'
                                            ? value
                                            : JSON.stringify(value, null, 2);
                                        setDialogContent(content || '');
                                        setOpenDialog(true);
                                      }}
                                    ></Button>
                                  )
                                ) : format === 'status' ? (
                                  <div
                                    className={`status-circle ${
                                      (typeof value === 'boolean' && value) ||
                                      value === 'true' ||
                                      value === 1
                                        ? 'active'
                                        : ''
                                    }`}
                                  >
                                    {(typeof value === 'boolean' && value) ||
                                    value === 'true' ||
                                    value === 1
                                      ? translating.active
                                      : row.numberOfAppointments !== null
                                      ? translating.cancelled
                                      : translating.blocked}
                                  </div>
                                ) : format === 'price' ? (
                                  <div>{`${value} ₪`}</div>
                                ) : format === 'updateStatus' &&
                                  row?.statusId === 13 ? (
                                  <Button
                                    txt={'עדכן סטטוס'}
                                    handleClick={() =>
                                      handleAction(
                                        row?.client_product_uuid ||
                                          row?.ClientProductId
                                      )
                                    }
                                  ></Button>
                                ) : (
                                  format === 'toggleSwitch' && (
                                    <Switch
                                      checked={row.isActive}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        handleAction(row?.id, row.isActive);
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                      color="primary"
                                      size="small"
                                    />
                                  )
                                )
                              ) : isArray ? (
                                arrValues
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            )}
          </Table>
        ) : (
          <div className="no-results">no results</div>
        )}
      </TableContainer>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {dialogContent}
          </pre>
        </DialogContent>
      </Dialog>
      {pagination &&
      currentRows &&
      rows &&
      rows.length &&
      currentRows.length > rowsPerPage ? (
        <Pagination
          classes={{ root: 'paginationRoot' }}
          count={count}
          page={page + 1}
          onChange={handleChangePage}
        />
      ) : null}
    </div>
  );
};

export default TablePaginationComponent;

TablePaginationComponent.propTypes = {
  headers: PropTypes.array,
  columns: PropTypes.array,
  rows: PropTypes.array,
  handleRowClick: PropTypes.func,
  handleRightClick: PropTypes.func,
  pagination: PropTypes.bool,
  useUId: PropTypes.bool
};
